module.exports = __webpack_public_path__ + "img/logo-citigroup.801282b2.png";